<template>
  <div class="SelectCard">
    <div class="SelectCard-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        输入卡号
      </div>
      <div class="SelectCard-choice">
        <el-input v-model="SeCardnum" :placeholder="this.SeSelect == '4' ? '请选择转出卡号' : '请选择转入卡号'" disabled @input="SeCardber()"></el-input>
        <button><router-link :to="{path: 'CardBag',query: {HoCardBag: '2',secaus: this.SeSelect,sempte: this.sealge}}">选择卡号</router-link></button>
      </div>
      <button class="SelectCard-confirm" @click="secorm()">确认</button>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + selefail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{seletips}}</p>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      SeCardnum: '',
      SeSelect: '',
      selefail: 'none',
      seletips: '',
      serale: '',
      seingl: '',
      selknt: '',
      sealge: '',
      setral: ''
    }
  },
  created () {
    // 接收首页(卡包)传过来的状态
    this.SeSelect = this.$route.query.HoSelect;
    // 接收我的传过来判断返回页面的状态
    this.sealge = this.$route.query.persalge;
    // 接收卡包传过来的被选中卡的信息
    this.SeCardnum = this.$route.query.cactrd;
    this.serale = this.$route.query.carale;
    this.seingl = this.$route.query.caingl;
    this.selknt = this.$route.query.calknt;
    this.setral = this.$route.query.catral;
  },
  mounted () {

  },
  methods: {
    // 获取用户输入的卡号
    SeCardber(){
      // console.log(this.SeCardnum);
    },
    // 点击确认判断卡号不能为空
    secorm(){
      if(!this.SeCardnum){
        this.seletips = '卡号不能为空';
        this.selefail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.selefail = 'none';
        },1200)
      }else{
        if(this.SeSelect == '0'){
          this.$router.push({name: 'PlayOpel',query: {sechbr: this.SeCardnum}});
        }else if(this.SeSelect == '1'){
          this.$router.push({name: 'ExchCord',query: {sechbr: this.SeCardnum}});
        }else if(this.SeSelect == '2'){
          this.$router.push({name: 'balance',query: {sechbr: this.SeCardnum,sebace: this.serale,seinal: this.seingl,selent: this.selknt,sepste: this.sealge}});
        }else if(this.SeSelect == '3'){
          this.$router.push({name: 'integral',query: {sechbr: this.SeCardnum,seheus: this.sealge,seigal: this.setral}});
        }else if(this.SeSelect == '4'){
          this.$router.push({name: 'TranActs',query: {sechbr: this.SeCardnum}});
        }else if(this.SeSelect == '5'){
          this.$router.push({name: 'TranPost',query: {sechbr: this.SeCardnum}});
        }
      }
    },
    // 返回上一层
    BackLevel(){
      if(this.sealge == '1'){
        this.$router.push({name: 'PersCent'});
      }else{
        this.$router.push({name: 'HomePage'});
      }
    }
  }
}
</script>

<style scoped>
  @import "obraocs/SelectCard.css";
</style>